export default __webpack_public_path__ + "static/space-4-78b6f9d0ebd8ee6cf1dc9d0895b0de58.jpg";